import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import sniffer from 'sniffer';
import { getActiveSchool } from 'helpers/guardian';
import MenuPage from "../Menu/Page";
import { setPageTitle } from 'actions/header';
import { getUnreadNotifications, postRegisterPush } from 'actions/notifications';
import { Icon, translate } from '@haldor/ui';
var FooterMenu = /*#__PURE__*/function (_Component) {
  function FooterMenu() {
    var _this;
    _classCallCheck(this, FooterMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FooterMenu, [].concat(args));
    _defineProperty(_this, "state", {
      isMenuOpen: false
    });
    _defineProperty(_this, "toggleMenu", function () {
      _this.setState(function (prevState) {
        return {
          isMenuOpen: !prevState.isMenuOpen
        };
      });
    });
    _defineProperty(_this, "componentDidMount", function () {
      _this.props.getUnreadNotifications(_this.props.activeStudent.id);
      document.addEventListener('route_change', function () {
        _this.props.getUnreadNotifications(_this.props.activeStudent.id);
      });
    });
    _defineProperty(_this, "getUnreadForItem", function (itemURL) {
      if (_this.props.unreadNotifications != null) {
        if (itemURL == '/conversations') {
          if (_this.props.unreadNotifications.conversations != null && parseInt(_this.props.unreadNotifications.conversations) > 0) {
            return _this.props.unreadNotifications.conversations;
          }
        }
        if (itemURL == '/notifications') {
          if (_this.props.unreadNotifications.events != null && parseInt(_this.props.unreadNotifications.events) > 0) {
            return _this.props.unreadNotifications.events;
          }
        }
        if (itemURL == '/posts') {
          if (_this.props.unreadNotifications.posts != null && parseInt(_this.props.unreadNotifications.posts) > 0 || _this.props.unreadNotifications.documentations != null && parseInt(_this.props.unreadNotifications.documentations) > 0) {
            var _this$props$unreadNot, _this$props$unreadNot2;
            return ((_this$props$unreadNot = _this.props.unreadNotifications.posts) !== null && _this$props$unreadNot !== void 0 ? _this$props$unreadNot : 0) + ((_this$props$unreadNot2 = _this.props.unreadNotifications.documentations) !== null && _this$props$unreadNot2 !== void 0 ? _this$props$unreadNot2 : 0);
          }
        }
      }
      return null;
    });
    _defineProperty(_this, "renderRegularItems", function () {
      var _this$props = _this.props,
        activeStudent = _this$props.activeStudent,
        translate = _this$props.translate;
      var isMenuOpen = _this.state.isMenuOpen;
      var items = [];
      var school = null;
      var schoolId = getActiveSchool(activeStudent.id);
      if (schoolId != null) {
        school = activeStudent.schools.find(function (t) {
          return t.id == schoolId;
        });
      } else {
        school = activeStudent.schools[0];
      }
      if (school != null && school.type != "PRESCHOOL") {
        items.push( /*#__PURE__*/React.createElement("div", {
          className: "menu-item-container",
          key: 'item-schedule'
        }, /*#__PURE__*/React.createElement(Link, {
          onClick: isMenuOpen ? function () {
            return _this.toggleMenu();
          } : null,
          to: "/schedule",
          activeClassName: "is-active",
          className: "menu-item"
        }, /*#__PURE__*/React.createElement("div", {
          className: "menu-item-icon"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Calendar"
        })), /*#__PURE__*/React.createElement("span", null, translate('Schedule')))));
      } else {
        items.push( /*#__PURE__*/React.createElement("div", {
          className: "menu-item-container",
          key: 'item-posts'
        }, /*#__PURE__*/React.createElement(Link, {
          onClick: isMenuOpen ? function () {
            return _this.toggleMenu();
          } : null,
          to: "/posts",
          activeClassName: "is-active",
          className: "menu-item"
        }, /*#__PURE__*/React.createElement("div", {
          className: "menu-item-icon"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Post"
        }), _this.getUnreadForItem('/posts') != null ? /*#__PURE__*/React.createElement("span", {
          className: "badge",
          style: {
            display: 'inline-flex',
            justifyContent: 'center',
            fontSize: '.7rem'
          }
        }, _this.getUnreadForItem('/posts')) : null), /*#__PURE__*/React.createElement("span", null, translate('Posts')))));
      }
      items.push( /*#__PURE__*/React.createElement("div", {
        className: "menu-item-container",
        key: 'item-plans'
      }, /*#__PURE__*/React.createElement(Link, {
        onClick: isMenuOpen ? function () {
          return _this.toggleMenu();
        } : null,
        to: "/plans",
        activeClassName: "is-active",
        className: "menu-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plans"
      })), /*#__PURE__*/React.createElement("span", null, translate('Plans')))));
      return items;
    });
    _defineProperty(_this, "renderTeamsItems", function () {
      var translate = _this.props.translate;
      var isMenuOpen = _this.state.isMenuOpen;
      return [/*#__PURE__*/React.createElement("div", {
        className: "menu-item-container"
      }, /*#__PURE__*/React.createElement(Link, {
        onClick: isMenuOpen ? function () {
          return _this.toggleMenu();
        } : null,
        to: "/notifications",
        activeClassName: "is-active",
        className: "menu-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bell"
      }), _this.getUnreadForItem('/notifications') != null ? /*#__PURE__*/React.createElement("span", {
        className: "badge",
        style: {
          display: 'inline-flex',
          justifyContent: 'center',
          fontSize: '.7rem'
        }
      }, _this.getUnreadForItem('/notifications')) : null), /*#__PURE__*/React.createElement("span", null, translate('Events')))), /*#__PURE__*/React.createElement("div", {
        className: "menu-item-container"
      }, /*#__PURE__*/React.createElement(Link, {
        onClick: isMenuOpen ? function () {
          return _this.toggleMenu();
        } : null,
        to: "/conversations",
        activeClassName: "is-active",
        className: "menu-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Message"
      }), _this.getUnreadForItem('/conversations') != null ? /*#__PURE__*/React.createElement("span", {
        className: "badge",
        style: {
          display: 'inline-flex',
          justifyContent: 'center',
          fontSize: '.7rem'
        }
      }, _this.getUnreadForItem('/conversations')) : null), /*#__PURE__*/React.createElement("span", null, translate('Messages'))))];
    });
    return _this;
  }
  _inherits(FooterMenu, _Component);
  return _createClass(FooterMenu, [{
    key: "render",
    value: /* Render methods */
    function render() {
      var _this2 = this;
      if (!sniffer.isDevice) {
        return null;
      }
      var isMenuOpen = this.state.isMenuOpen;
      var translate = this.props.translate;
      var currentStudentHaveUnreads = false;

      // Find out if user have unread events/conversations/posts/documentaions on current child/student
      if (this.props.unreadNotifications != null) {
        currentStudentHaveUnreads = this.props.unreadNotifications.events != null && parseInt(this.props.unreadNotifications.events) > 0 || this.props.unreadNotifications.conversations != null && parseInt(this.props.unreadNotifications.conversations) > 0 || this.props.unreadNotifications.posts != null && parseInt(this.props.unreadNotifications.posts) > 0 || this.props.unreadNotifications.documentations != null && parseInt(this.props.unreadNotifications.documentations) > 0;
      }
      return /*#__PURE__*/React.createElement("div", null, isMenuOpen && /*#__PURE__*/React.createElement(MenuPage, {
        className: isMenuOpen ? 'is-open' : '',
        onClose: function onClose() {
          return _this2.toggleMenu();
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "footer-menu-bar-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-container"
      }, /*#__PURE__*/React.createElement(Link, {
        onClick: isMenuOpen ? function () {
          _this2.toggleMenu(), _this2.props.getUnreadNotifications(_this2.props.activeStudent.id);
        } : function () {
          return _this2.props.getUnreadNotifications(_this2.props.activeStudent.id);
        },
        to: "/",
        activeClassName: "is-active",
        className: "menu-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "House"
      })), /*#__PURE__*/React.createElement("span", null, translate('Home')))), this.props.activeStudent != null && this.props.activeStudent.services.msAssignmentOutcomes ? this.renderTeamsItems() : this.renderRegularItems(), /*#__PURE__*/React.createElement("div", {
        className: "menu-item-container"
      }, /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: function onClick() {
          return _this2.toggleMenu();
        },
        activeClassName: "is-active",
        className: "menu-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Burger"
      }), currentStudentHaveUnreads ? /*#__PURE__*/React.createElement("div", {
        className: "badge",
        style: {
          background: 'none',
          border: 'none'
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Alert_Red"
      })) : null), /*#__PURE__*/React.createElement("span", null, translate('More'))))));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    activeStudent: state.User.activeStudent,
    activeSchool: state.User.activeSchool,
    user: state.User.user,
    pathname: document.location.pathname,
    translate: translate(state.Languages.translations),
    unreadNotifications: state.Notifications.unreadNotifications
  };
}
export default connect(mapStateToProps, {
  getUnreadNotifications: getUnreadNotifications,
  postRegisterPush: postRegisterPush,
  setPageTitle: setPageTitle
}, null, {
  pure: false
})(FooterMenu);